<template>
  <print297 v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 관리감독자 정보 -->
    <div class="mt-5 mb-6">
      <p class="title my-4"><i class="dot"></i>관리감독자 정보</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_1 }} </span>
          <ml-input v-else :readonly="board.readonly" class="w-full flex-1" placeholder="" v-model="form.inputC_1" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>
          <ml-input v-else :readonly="board.readonly" class="w-full flex-1" placeholder="" v-model="form.inputC_2" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">직책</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_3 }} </span>
          <ml-input v-else :readonly="board.readonly" class="w-full flex-1" placeholder="" v-model="form.inputC_3" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_5 }} </span>
          <DateSelector v-else :readonly="board.readonly" class="w-full flex-1" placeholder="날짜선택" v-model="form.inputC_5" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">종료일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_6 }} </span>
          <DateSelector v-else :readonly="board.readonly" class="w-full flex-1" placeholder="날짜선택" v-model="form.inputC_6" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">교육 이수일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_7 }} </span>
          <DateSelector v-else :readonly="board.readonly" class="w-full flex-1" placeholder="날짜선택" v-model="form.inputC_7" />
        </div>
      </div>
    </div>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import SearchNavStartEnd from "../../../../components/nav/SearchNavStartEnd.vue";
import FileUploadModule from "../../../modules/FileUploadModule.vue";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import Print297 from "@/views/boards/single-page/297/Print";
import moment from "moment";

export default {
  components: {
    Print297,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    if (this.value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},

        dateStatus: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",

        fileList: [],
        companyName: "",
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.companyName = value.com_name;
      this.form.inputB_2 = value.com_ceo;
      this.form.inputB_3 = value.com_tel;
      this.form.inputB_4 = value.com_address;
    },

    validate() {
      const start = this.form.inputC_5 ? moment(this.form.inputC_5) : null;
      const end = this.form.inputC_6 ? moment(this.form.inputC_6) : null;
      const now = moment();

      if (!start) this.form.dateStatus = "";
      const sD = moment.duration(start.diff(now)).asDays();

      if (1 <= sD) this.form.dateStatus = "";
      else if (end) {
        const eD = moment.duration(end.diff(now)).asDays();
        if (-1 < eD) this.form.dateStatus = "선임";
        else this.form.dateStatus = "종료";
      } else this.form.dateStatus = "선임";

      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
</style>
